





































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./tester_add.vue";

@Component({
  components: {
    Add
  }
})
export default class extends Mixins(MyList) {
  @Prop() appid!: string;

  columns: any[] = [
    { title: "唯一字符串", dataIndex: "userstr" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadTesters();
  }

  async loadTesters() {
    this.loading = true;
    const res = await this.$store.dispatch("oplatformapps/testers", {
      appid: this.appid
    });

    this.loading = false;

    if (res && res.Data) {
      this.data = res.Data;
    }
  }

  showAddModal1() {
    this.addModalVisible = true;
  }

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadTesters();
  }

  handleDelete1(userstr: string) {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要删除该体验者吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/unbindTester", {
          appid: this.appid,
          userstr
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadTesters();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
